import React from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash/noop';

import PlusIcon from '@ott/icon-plus';
import MinusIcon from '@ott/icon-minus';

import cls from 'classnames/bind';
import s from './PlusMinus.scss';
const cx = cls.bind(s);

class PlusMinus extends React.PureComponent {
  static propTypes = {
    value: PropTypes.number.isRequired,
    label: PropTypes.node,
    min: PropTypes.number.isRequired,
    max: PropTypes.number.isRequired,
    getQuantityLabel: PropTypes.func,
    onChange: PropTypes.func.isRequired,
    specificLocators: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    childrenClassNames: PropTypes.shape({
      container: PropTypes.string,
      quantity: PropTypes.string,
      minus: PropTypes.string,
      plus: PropTypes.string,
    }),
  };

  static defaultProps = {
    getQuantityLabel: value => value,
    onChange: _noop,
    childrenClassNames: {
      container: '',
      quantity: '',
      minus: '',
      plus: '',
    },
  };

  handlePlusClick = () => {
    const { value, max, onChange } = this.props;
    if (value < max) {
      onChange(value + 1);
    }
  };

  handleMinusClick = () => {
    const { value, min, onChange } = this.props;
    if (value > min) {
      onChange(value - 1);
    }
  };

  render() {
    const { value, min, max, label, specificLocators, childrenClassNames } = this.props;

    const minusIsActive = value > min;
    const plusIsActive = value < max;

    return (
      <div
        className={cx('PlusMinus', childrenClassNames.container)}
        data-locator={cls('PlusMinus', specificLocators)}
      >
        <div
          className={cx('minus', childrenClassNames.minus, {
            'minus--isDisabled': !minusIsActive,
          })}
          onClick={this.handleMinusClick}
          data-locator="minus-trigger"
        >
          <MinusIcon className={cx('icon')} />
        </div>
        <div
          className={cx('quantity', childrenClassNames.quantity, {
            'quantity--left-disabled': !minusIsActive,
            'quantity--right-disabled': !plusIsActive,
          })}
          data-locator="quantity"
        >
          {label || value}
        </div>
        <div
          className={cx('plus', childrenClassNames.plus, {
            'plus--isDisabled': !plusIsActive,
          })}
          onClick={this.handlePlusClick}
          data-locator="plus-trigger"
        >
          <PlusIcon className={cx('icon')} />
        </div>
      </div>
    );
  }
}

export default PlusMinus;
